<template>
  <div>
      <Modal v-if="visible" v-model="visible"
             :visible="visible"
             :title="detail.id ? '修改说明' : '新增说明'"
             :showFooter="false"
             :overlayOpacity="0.5"
             @update:visible="visible = $event"
             contentWidth="30%"
      >
          <div>
              <form>
                  <div class="form-group-list">
                      <SelectField
                              label="任务类型"
                              labelWidth="25%"
                              id="type"
                              :modelValue="detail.type"
                              :options="typeList"
                              required
                              @update:modelValue="(value) => handleModelValueUpdate('type', value)"
                      />
                  </div>
                  <div class="form-group-list">
                      <InputField
                          label="任务说明"
                          labelWidth="25%"
                          type="text"
                          id="remark"
                          :modelValue="detail.remark"
                          placeholder="请输入任务说明"
                          required
                          @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                      />
                  </div>
                  <div class="form-group-button">
                      <ButtonField text="关闭" @click="cancel" secondary width="30%"/>
                      <ButtonField text="保存" primary width="30%" @click="handleSubmit"/>
                  </div>
              </form>
          </div>
      </Modal>
  </div>
</template>

<script>
import request from "@/api/request";
function add(data) {
  return request({
    url: "/model-analysis/inspect/task/remark/save",
    method: "post",
    data,
  });
}

function edit(data) {
  return request({
    url: "/model-analysis/inspect/task/remark/modify",
    method: "post",
    data,
  });
}
import { mapGetters } from "vuex";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import Modal from '@/components/water-affairs-style/modal.vue';
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
      SelectField, ButtonField,Modal
  },
  data() {
    return {
      form: {
          type:null,
          remark:null
      },
      saveLoading: false,
      remarkList:[]
    };
  },
    computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("taskType");
    },
  },

  methods: {
      handleModelValueUpdate(fieldName, value) {
          this.form[fieldName] = value;
      },
      cancel() {
          // this.form.resetFields();
          this.$emit("cancel");
      },
    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;

        this.form = this.detail

        if (!this.form.type) {
            this.$message.error('任务类型不能为空');
            this.isSubmitting = false; // 重置标志
            return;
        }
        if (!this.form.remark) {
            this.$message.error('任务说明不能为空');
            this.isSubmitting = false;
            return;
        }
          let task = add;
          if (this.detail.id) {
            task = edit;
          }

          task({
              ...this.detail,
              ...this.form
          })
            .then(() => {
              this.cancel();
              this.$emit("refresh");
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        }
  },
};
</script>

<style lang="less" scoped>
.card {
  position: fixed;
  top: 11vh;
  right: 1vw;
  z-index: 99;
  width: 40vw;
  background-color: #fff;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  height: 75vh;
  overflow: auto;

  & > .header {
    background-color:  rgba(10, 20, 40, 0.6);
    position: sticky;
    top: 0;
    left: 0;
    z-index: 998;
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}

.form {
  padding: 1em;

  .center {
    padding: 40px;
  }
}
.form-group-button{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.form-group-list{
    margin: 1.5rem 0;
}
</style>
